/** Tài nguyên + CSS dùng chung cho theme "Giải cứu đại dương" (solo + chơi trên lớp). */
export const ASSET = "/games/giai-cuu-dai-duong";

/** Nhãn A–D + khung ảnh đáp án tương ứng. */
export const ANSWERS = [
  { letter: "A", img: `${ASSET}/ans-a.png` },
  { letter: "B", img: `${ASSET}/ans-b.png` },
  { letter: "C", img: `${ASSET}/ans-c.png` },
  { letter: "D", img: `${ASSET}/ans-d.png` },
];

/* CSS theo container-query (cqw/cqh) để chữ & nút co giãn theo khung game,
   chạy đẹp cả khi nhúng nhỏ lẫn toàn màn hình — tránh vỡ layout. */
export const ORX_CSS = `
.orx-frame{ container-type: size; font-family: var(--font-sans, "Be Vietnam Pro", system-ui, sans-serif); }
.orx-ctrl{ width:5cqw; height:5cqw; min-width:26px; min-height:26px; display:grid; place-items:center;
  padding:1.1cqw; border-radius:999px; color:#fff; background:#0577c7e6; box-shadow:0 0.3cqw 0.6cqw #00365780; cursor:pointer; }
.orx-ctrl:hover{ background:#0a86dc; transform:scale(1.06); }
.orx-btn{ border:0; cursor:pointer; font-weight:700; color:#fff; border-radius:999px;
  padding:1.4cqw 4cqw; font-size:clamp(14px,2.4cqw,30px); line-height:1;
  box-shadow:0 0.4cqw 0.7cqw #0000003a; transition:transform .15s, filter .15s; }
.orx-btn:hover{ transform:scale(1.05); filter:brightness(1.05); }
.orx-btn-primary{ background:linear-gradient(#ff9a3d,#f2701d); border:0.35cqw solid #fff; }
.orx-btn-ghost{ background:#0577c7e6; border:0.35cqw solid #ffffffcc; }
.orx-btn-finish{ background:linear-gradient(#40d977,#0b9d45); border:0.35cqw solid #fff; }
.orx-btn-disabled{ opacity:.45; filter:grayscale(.5); cursor:not-allowed; }
.orx-btn-disabled:hover{ transform:none; }
.orx-pill{ display:inline-block; padding:1cqw 2.4cqw; border:0.3cqw solid #fff; border-radius:999px;
  background:#057fcbe8; color:#fff; font-weight:700; box-shadow:0 0.25cqw 0.5cqw #00446d55;
  font-size:clamp(12px,2cqw,26px); }
.orx-title-pill{ background:#063b68e6; }
.orx-progress{ font-size:clamp(12px,1.9cqw,24px); }
.orx-time{ color:#fff; font-weight:700; font-size:clamp(12px,1.9cqw,24px); text-shadow:0 0.15cqw 0.15cqw #084361; }
.orx-guide-text{ color:#0e3a55; font-weight:700; font-size:clamp(12px,2.1cqw,26px); line-height:1.3; }
.orx-trash{ height:26cqh; padding:0; border:0; background:transparent; cursor:pointer;
  filter:drop-shadow(0 0.4cqw 0.3cqw #06496b45); transition:transform .18s, filter .18s, opacity .18s; }
.orx-trash:hover{ transform:scale(1.08) translateY(-0.4cqw); filter:brightness(1.08) drop-shadow(0 0.6cqw 0.5cqw #003f6870); z-index:5; }
.orx-trash-saved{ opacity:.35; filter:grayscale(.15) brightness(1.05); cursor:default; transform:scale(.82); }
.orx-trash-polluted{ opacity:.3; filter:grayscale(.9); cursor:default; transform:scale(.82); }
.orx-badge{ position:absolute; top:-4%; right:-4%; display:grid; place-items:center; width:34%; height:34%;
  min-width:18px; min-height:18px; border-radius:999px; color:#fff; font-weight:700;
  font-size:clamp(11px,2cqw,22px); box-shadow:0 0.2cqw 0.4cqw #0003; }
.orx-badge-ok{ background:#12b364; border:0.25cqw solid #fff; }
.orx-badge-bad{ background:#e0485a; border:0.25cqw solid #fff; }
.orx-back{ width:6cqw; height:6cqw; min-width:30px; min-height:30px; padding:1.3cqw; display:grid; place-items:center;
  border:0; border-radius:999px; color:#fff; background:#0577c7e6; box-shadow:0 0.3cqw 0.6cqw #00365780; cursor:pointer; }
.orx-back:hover{ background:#0a86dc; transform:scale(1.06); }
.orx-qtext{ color:#173b52; font-weight:700; font-size:clamp(14px,2.9cqw,40px); line-height:1.2; }
.orx-answer{ aspect-ratio:auto; height:16cqh; padding:0; border:0; background:transparent; cursor:pointer;
  transition:transform .16s, filter .16s, opacity .16s; }
.orx-answer:hover{ transform:scale(1.04); filter:brightness(1.06) drop-shadow(0 0.4cqw 0.4cqw #003f6850); z-index:5; }
.orx-atext{ color:#173b52; font-weight:700; font-size:clamp(12px,2.1cqw,28px); line-height:1.15; }
.orx-answer-correct{ filter:brightness(1.1) drop-shadow(0 0 1cqw #64ff72); }
.orx-answer-wrong{ animation:orxShake .35s; filter:drop-shadow(0 0 1cqw #ff5050); }
.orx-feedback{ color:#fff; font-weight:700; font-size:clamp(13px,2.2cqw,30px); text-shadow:0 0.15cqw 0.15cqw #084361; white-space:nowrap; }
.orx-end-score{ color:#0e3a55; font-weight:700; font-size:clamp(14px,2.6cqw,34px); }
.orx-result{ background:#ffffffee; border-radius:1.2cqw; padding:1.4cqw 1.8cqw; box-shadow:0 0.4cqw 0.8cqw #00365740; }
.orx-turtle-net{ animation:orxFloat 4.5s ease-in-out infinite; }
.orx-float{ animation:orxFloat 3.6s ease-in-out infinite; }
.orx-swim-l{ animation:orxSwimL 4.2s ease-in-out infinite; filter:drop-shadow(0 0.5cqw 0.35cqw #06496b45); }
.orx-swim-r{ animation:orxSwimR 4.8s ease-in-out infinite; filter:drop-shadow(0 0.5cqw 0.35cqw #06496b45); }
@keyframes orxFloat{0%,100%{transform:translateY(0) rotate(-2deg)}50%{transform:translateY(-1cqh) rotate(2deg)}}
@keyframes orxSwimL{0%,100%{transform:translate(0) rotate(-2deg)}45%{transform:translate(1cqw,-1cqh) rotate(3deg)}}
@keyframes orxSwimR{0%,100%{transform:translate(0) rotate(2deg)}45%{transform:translate(-0.8cqw,-1cqh) rotate(-3deg)}}
@keyframes orxShake{25%{transform:translateX(-1.5%)}50%{transform:translateX(1.5%)}75%{transform:translateX(-0.8%)}}
.orx-confetti{ position:absolute; top:-8%; will-change:transform,opacity; pointer-events:none; line-height:1; }
@keyframes orxFall{ 0%{transform:translate(0,-10cqh) rotate(0deg);opacity:0} 12%{opacity:1} 86%{opacity:1} 100%{transform:translate(var(--dx),110cqh) rotate(var(--r));opacity:0} }
.orx-pop{ animation:orxPop .5s cubic-bezier(.2,1.4,.4,1) both; }
@keyframes orxPop{ 0%{transform:scale(.4);opacity:0} 55%{transform:scale(1.15)} 100%{transform:scale(1);opacity:1} }
@media (prefers-reduced-motion: reduce){ .orx *{ animation:none !important; } }
`;
